export const staffNameByUid = (uid, staffMembers) => {
  if (!uid || !staffMembers) return ''
  const staff = staffMembers.find(member => member.uid === uid)
  return (staff && staff.full_name) || ''
}
